export default __webpack_public_path__ + "static/media/hero-img-02.580e3f7c.png";